import { AUTH_FLOW_DEVICE_PATH_LOGIN } from '../ph-auth-routes';
import { DeviceComponent } from './device.component';

export const AUTH_FLOW_DEVICE_ROUTES = [
  { path: AUTH_FLOW_DEVICE_PATH_LOGIN, component: DeviceComponent },
];
